export default {
  methods: {
    ssnEmpty (ssn) {
      return ssn === ' ' || ssn === '' || ssn === null || ssn === undefined
    }
  },

  computed: {
    maskedSsn () {
      return (ssn) => {
        if (this.ssnEmpty(ssn)) { return '' }

        let strippedSsn = ssn.replace(/\D/g, '')
        return `######${strippedSsn.substr(-4)}`
      }
    },

    maskedClientHealthId () {
      return (ssn, clientHealthId) => {
        if (this.ssnEmpty(ssn) || !this.ssnMatchesClientHealthId(ssn, clientHealthId)) { return clientHealthId }

        let strippedSsn = ssn.replace(/\D/g, '')
        let split = clientHealthId.replace(strippedSsn, `,${strippedSsn},`).split(',')

        return split.map(splitString => {
          if (splitString === strippedSsn) { return `######${strippedSsn.substr(-4)}` } else { return splitString }
        }).join('')
      }
    },
    ssnMatchesClientHealthId() {
      return (ssn, clientHealthId) => {
        if (this.ssnEmpty(ssn)) { return false }

        try {
          let [
            strippedSsn,
            strippedClientHealthId
          ] = [
            ssn.replace(/\D/g, ''),
            clientHealthId.replace(/\D/g, '')
          ]

          return strippedSsn === strippedClientHealthId
        } catch (error) {
          return false
        }
      }
    }
  }
}
